export default "__VITE_ASSET__DMk2fJ8t__"